var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"extraLarge":"","title":"Arquivos"}},[_c('Form',{ref:"Form",attrs:{"additionals":_vm.additionals,"uploads":_vm.uploads,"item":_vm.item,"solicitacao":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }